import React from 'react'
import { Col, DatePicker, Form, Input } from 'antd'
import { get } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../modules/FormItems'
import { dateVal } from '../../../modules/Utils'
import { compose } from 'recompose'
import withData from '../../../elements/Select/withData'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'

const { TextArea } = Input
const StatusSelect = compose(
  withData({
    data: [{ key: 'Closed', value: 'Closed' }, { key: 'Active', value: 'Active' }],
  }),
  withSort,
)(CustomSelect)

function CatalogForm (props) {
  const { getFieldDecorator } = props.form
  const { catalog } = props
  return (
    <Form>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Part No'}>
          {getFieldDecorator('material_no', {
            initialValue: get(catalog, 'material_no'),
            rules: rules.input,
          })(<Input placeholder={'Part No'}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Name'}>
          {getFieldDecorator('name', {
            initialValue: get(catalog, 'name'),
            rules: rules.input,
          })(<Input placeholder={'Name'}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Description'}>
          {getFieldDecorator('description', {
            initialValue: get(catalog, 'description'),
            rules: rules.input,
          })(<TextArea autosize={true} placeholder={'Description'}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Notice Period'}>
          {getFieldDecorator('date', {
            initialValue: dateVal(catalog, 'date'),
            rules: rules.select,
          })(<DatePicker style={{ width: '100%' }}/>)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...defaultFormItemLayout} label={'Status'}>
          {getFieldDecorator('status', {
            initialValue: get(catalog, 'status') || 'Active',
            rules: rules.select,
          })(<StatusSelect placeholder={'Status'}/>)}
        </Form.Item>
      </Col>
    </Form>
  )
}

CatalogForm.propTypes = {}
CatalogForm.defaultProps = {}

export default Form.create()(CatalogForm)
